import React, { useEffect, useState } from 'react';
import { material } from '../../../library/material';
import { Controller, useForm } from 'react-hook-form';
import Snackbar from '../../toastrmessage/Snackbar';
import { getVendorByClinicId } from '../../../services/VendorManagementService';
import { saveOrUpdateOtherProduct } from '../../../services/OtherStockService';

function AddOrEditOtherProduct(props) {

    const { openAddOrEditOtherProduct, setOpenAddOrEditOtherProduct, userDetails, clinicDetails, getOtherProductList, rowsPerPage, page } = props;
    const { register, handleSubmit, reset, setValue, control, formState: { errors, isValid } } = useForm({
        mode: "onTouched"
    });
    const [supplierName, setSupplierName] = useState([]);
    const [supplierId, setSupplierId] = useState(null);
    const [supplierList, setSupplierList] = useState([]);
    const [openSnackBar, setOpenSnackBar] = useState({
        "action": false,
        "type": "",
        "message": "",
    });

    useEffect(() => {
        if (openAddOrEditOtherProduct.action && openAddOrEditOtherProduct.data) {
            getSuppliers();
            reset(openAddOrEditOtherProduct.data);
        } else if (openAddOrEditOtherProduct.action && openAddOrEditOtherProduct.data == null) {
            getSuppliers();
        }
    }, [openAddOrEditOtherProduct.action]);

    const getSuppliers = async () => {
        await getVendorByClinicId(clinicDetails.clinicId)
            .then((res) => {
                let supplierName = res.data?.data?.map((ele) => ele.companyName)
                setSupplierName(supplierName);
                setSupplierList(res.data.data)
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setOpenSnackBar({
                        "action": true,
                        "type": "error",
                        "message": error.response.data.data.info,
                    })
                } else {
                    setOpenSnackBar({
                        "action": true,
                        "type": "error",
                        "message": error.response.data.messages,
                    })
                }
            })
    };

    const saveOtherProduct = (data) => {
        const payload = {
            orgId: userDetails.orgId,
            clinicId: clinicDetails.clinicId,
            ...data
        }
        saveOrUpdateOtherProduct(payload)
            .then((resp) => {
                const payload = {
                    page: page,
                    limit: rowsPerPage
                }
                getOtherProductList(payload);
                setOpenSnackBar({
                    "action": true,
                    "type": "success",
                    "message": resp.data.data,
                })
                close();
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setOpenSnackBar({
                        "action": true,
                        "type": "error",
                        "message": error.response.data.data.info,
                    })
                } else {
                    setOpenSnackBar({
                        "action": true,
                        "type": "error",
                        "message": error.response.data.data,
                    })
                }
            })
    };

    const close = () => {
        reset({ supplier: '', product: '', productType: '' });
        setSupplierId(null);
        setSupplierName([]);
        setOpenAddOrEditOtherProduct({ action: false, data: null });
    };

    return (
        <div>
            <material.Dialog open={openAddOrEditOtherProduct.action} maxWidth="sm" fullWidth>
                <material.DialogTitle>{openAddOrEditOtherProduct.data ? "Edit Product" : "Add Product"}</material.DialogTitle>
                <material.DialogContent>
                    <div className="row">
                        <div className="col-12">
                            <Controller
                                name="supplier"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    <material.Autocomplete
                                        {...field}
                                        value={field.value}
                                        options={supplierName}
                                        renderInput={(params) => (
                                            <material.TextField
                                                required
                                                margin="dense"
                                                {...params}
                                                variant="standard"
                                                label="Supplier Name"
                                                fullWidth
                                            />
                                        )}
                                        onChange={(event, data) => {
                                            field.onChange(data);
                                        }}
                                    />
                                )}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <material.TextField
                                required
                                fullWidth
                                variant="standard"
                                label="Product Name"
                                id='productName'
                                {...register("product", { required: true })}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <material.TextField
                                required
                                fullWidth
                                variant="standard"
                                label="Product Type"
                                id='productType'
                                {...register("productType", { required: true })}
                            />
                        </div>
                    </div>
                </material.DialogContent>
                <material.DialogActions className='m-2'>
                    <material.Button variant="outlined" sx={{ textTransform: "none" }} size="medium" className='me-2' color='error' onClick={close} startIcon={<material.CloseIcon />}>
                        Cancel
                    </material.Button>
                    <material.Button variant="outlined" sx={{ textTransform: "none" }} onClick={handleSubmit(saveOtherProduct)} startIcon={<material.DoneIcon />}>{openAddOrEditOtherProduct.data ? "Update" : "Submit"}</material.Button>
                </material.DialogActions>
            </material.Dialog>
            <Snackbar
                openSnackBar={openSnackBar}
                setOpenSnackBar={setOpenSnackBar}
            />
        </div>
    );
}

export default AddOrEditOtherProduct;